<template>
  <div v-if="imgBase64" :style="{ left: imgLeft + 'px', top: imgTop + 'px' }">
    <img id="img" :src="imgBase64" />
  </div>
</template>
<script setup lang="ts">
import { ref, computed, watch } from 'vue';
import { useEditorStore } from '@/store/use-editor-store';
import { useImagesStore } from '@/store/use-images-store';
import { useWatchfaceStore } from '@/store/use-watchface-store';
import { getImageSize } from '@/utils/fs/image.utils';

const editorStore = useEditorStore();
const imagesStore = useImagesStore();
const watchfaceStore = useWatchfaceStore();

const imgWidth = ref<number>(0);
const imgHeight = ref<number>(0);

const imgBase64 = computed(() => {
  if (editorStore.sku.includes('https')) {
    return editorStore.sku;
  } else return imagesStore.image(editorStore.sku)?.value || '';
});

const getImg = async (base64value: string) => {
  if (!base64value.length) return;
  const imgShape = await getImageSize(undefined, base64value);
  imgWidth.value = imgShape?.width ?? 0;
  imgHeight.value = imgShape?.height ?? 0;
};

watch(
  () => imgBase64.value,
  (newVal) => {
    getImg(newVal);
  }
);

const imgLeft = computed(
  () =>
    editorStore.watchfaceCanvas.offsetX -
    (imgWidth.value - watchfaceStore.size.width) / 2 -
    (watchfaceStore.size.width * (1 - editorStore.watchfaceCanvas.scale)) / 2
);

const imgTop = computed(
  () =>
    editorStore.watchfaceCanvas.offsetY -
    (imgHeight.value - watchfaceStore.size.height) / 2 -
    (watchfaceStore.size.height * (1 - editorStore.watchfaceCanvas.scale)) / 2
);
</script>
